import React, { useEffect } from "react"
import { Divider, Grid, Typography } from "@material-ui/core"
import Modal from "./Modal"
import { formatarCodigoLote } from "../utils/Formatacao"
import { CODIGO_TECLA_P } from "../utils/Constantes"

const ModalLoteFinalizadoSucesso = ({
    editando,
    dadosLote,
    quantidadeAmostrasLote,
    modalAberto,
    setModalAberto,
    carregandoModal,
    handleChangeImprimir }) => {

    const permiteImpressao = dadosLote.etiquetaGeradaOnboarding && quantidadeAmostrasLote > 0;

    const handleFecharModal = () => {
        setModalAberto(false);
    }

    const botaoSair = ({
        texto: "Sair",
        acao: () => handleFecharModal(),
        carregando: carregandoModal,
        atalho: "(ESC)"
    });

    const botaoImprimir = ({
        texto: "Imprimir etiquetas",
        acao: () => handleChangeImprimir(),
        carregando: carregandoModal,
        atalho: "(CTRL + P)"
    });

    const dadoCabecalho = (nome, valor, style) => (
        <Grid item xs={12} className={style}>
            <Typography variant="body1" color="textPrimary">
                <span className="bold">{nome}:</span> {valor || "-"}
            </Typography>
        </Grid>
    );

    useEffect(() => {
        const registerShortcut = (event) => {
            if (event.ctrlKey && event.which === CODIGO_TECLA_P) {
                event.preventDefault();
                handleChangeImprimir();
            }
        }

        document.addEventListener('keydown', registerShortcut);

        return () => document.removeEventListener('keydown', registerShortcut);
    }, [handleChangeImprimir]);

    return (
        <Modal
            modalAberto={modalAberto}
            desabilitarCliqueForaModal={false}
            iconeFechar={true}
            maxWidth={"sm"}
            fecharModal={handleFecharModal}
            botaoSecundario={permiteImpressao && botaoSair}
            botaoPrincipal={permiteImpressao ? botaoImprimir : botaoSair}
        >
            <Grid container className="ml-3">
                <Grid item xs={12} className="mb-4 mt-4">
                    <Typography variant="h4">
                        {"Lote " + formatarCodigoLote(dadosLote.codigo) + (editando ? " editado com sucesso!" : " criado com sucesso!")}
                    </Typography>
                </Grid>

                {dadoCabecalho("Empresa", dadosLote.empresa?.descricao, "mb-1")}
                {dadoCabecalho("Tipo de lote", dadosLote.tipoLote?.descricao, "mb-1")}
                {dadoCabecalho("Conservação do lote", dadosLote.tipoConservacao?.descricao, "mb-1")}

                <Grid item xs={12}>
                    <Divider className="mb-1 mt-4 mr-6" />
                </Grid>

                <Grid item xs={12} className="mb-4 mt-4">
                    <Typography variant="h4">
                        Detalhes da etiqueta
                    </Typography>
                </Grid>

                {dadoCabecalho("Nº da etiqueta pré-impressa: ", formatarCodigoLote(dadosLote.codigo), "mb-3")}
            </Grid>
        </Modal>
    )
}

export default ModalLoteFinalizadoSucesso